const newsletterOverlayActive = ref(false);

export default () => {
  return { newsletterOverlayActive };
};
